import { subscriptionsListSaga } from './subscriptionsList';
import { soldSubscriptionsSaga } from './soldSubscriptions';

export const subscriptionsSaga = [
    ...subscriptionsListSaga,
    ...soldSubscriptionsSaga,
];
